import Splide from '@splidejs/splide';
import isEmail from 'validator/lib/isEmail';

import showError from './utils/show-error';

const CALL = {
  POST_SUBSCRIBE: base_url_api_v4 + '/subscribe?lang=' + lang,
}

document.addEventListener('DOMContentLoaded', function () {
    const navResearchSlide = document.querySelector(".navResearchSlide");
    const navContributionSlide = document.querySelector(".navContributionSlide");
    const formSubscribe  = document.getElementById('subscribe');

    //MAIN MENU ABOUT US
    var bannerMenu = new Splide( '.mpAbout-bannerMenu', {
        destroy: true,
        breakpoints: {
            768: { //under screen
                arrows: false,
                autoWidth: true,
                pagination: false,
                gap: 16,
            }
        }
    } ).mount();
    document.querySelectorAll(".mpAbout-bannerMenu li a").forEach((el, i) => {
        if ( i != 0 ) {
            if(el.classList.contains("active")) {
              bannerMenu.go( i + 1 );
            }
        }
    });

    formSubscribe.addEventListener('submit', (e) => {
      e.preventDefault();
      const containerNotification = document.getElementById("subscribeNotification");
      const email = formSubscribe.elements['email'];

      //DELETE LATEST VALIDATOR
      var elements = document.getElementsByClassName("error");
      while(elements.length > 0){
          elements[0].parentNode.removeChild(elements[0]);
      }

      //CHECK EMAIL
      if ( !isEmail(email.value) ) {
        showError(email, v_email);
      } else {
        const params = new URLSearchParams();
        params.append('email', email.value);

        submitSubscribe(params, formSubscribe, containerNotification);
      }
  });

    //SLIDER RESEARCH
    if ( navResearchSlide ) {
        var main = new Splide( '.contentResearchSlide', {
            type       : 'fade',
            pagination : false,
          } );
          
          var thumbnails = new Splide( '.navResearchSlide', {
            rewind          : true,
            autoWidth       : true,
            autoHeight      : true,
            isNavigation    : true,
            gap             : 67,
            focus : 'center',
            pagination      : false,
            arrows          : false,
            dragMinThreshold: {
              mouse: 4,
              touch: 10,
            },
            breakpoints : {
              640: {
                fixedWidth  : 66,
                fixedHeight : 38,
                arrows : false,
                focus : 'center',
                gap : 40,
                },
            },
          } ).mount();
          
          main.sync( thumbnails ).mount();
    }

    //SLIDE CONTRIBUTION
    if ( navContributionSlide ) {
      new Splide( '.navContributionSlide', {
        destroy: true,
        breakpoints: {
            768: { //under screen
                arrows: false,
                autoWidth: true,
                pagination: false,
                gap: 8,
            }
        }
      } ).mount();
      
    }
    
});

let myTimeout;

function submitSubscribe(params, formSubscribe, containerNotification) {
  window.clearTimeout(myTimeout);

  //DISABLE ELEMENTS FORM
  for (var i = 0, len = formSubscribe.length; i < len; ++i) {
    formSubscribe[i].disabled = true;
  }
  containerNotification.style.height = "0px";
  
  axios({
    method: 'post',
    url: CALL.POST_SUBSCRIBE,
    data: params
  })
  .then(function (response) {
    formSubscribe.reset();
    //REDISABLE ELEMENTS FORM
    for (var i = 0, len = formSubscribe.length; i < len; ++i) {
      formSubscribe[i].disabled = false;
    }
    
    //SHOW NOTIFICATION
    containerNotification.style.height = "";
    containerNotification.style.display = "block";
    containerNotification.innerHTML = response.data.msg;
    myTimeout = window.setTimeout(() => { containerNotification.style.display = "none"; }, 3000);
  })
  .catch(function (error) {
    const err = error.response;
    //REDISABLE ELEMENTS FORM
    for (var i = 0, len = formSubscribe.length; i < len; ++i) {
      formSubscribe[i].disabled = false;
    }

    //SHOW NOTIFICATION
    containerNotification.style.height = "";
    containerNotification.style.display = "block";
    containerNotification.innerHTML = err.data.msg ? err.data.msg : err.statusText;
    myTimeout = window.setTimeout(() => { containerNotification.style.display = "none"; }, 3000);
  });
}
